import React from 'react';
import './App.scss';
import ReduxContainer from './ReduxContainer';

export default () => <ReduxContainer />;
